import { create } from 'zustand';
import { getState, useState } from '@/framework';
import { IExportState, StateType } from '@/version-types';

/** 状态 */
interface IState {
    /** 移动图层 id */
    moveLayerId: string | null;
    /** 是否渲染通用 active 操作框 */
    activeRenderEnabled: boolean;
}

/** 动作 */
interface IAction {
    /** 设置移动图层 id */
    setMoveLayerId: (layerId: string | null) => void;
    /** 获取移动图层 id */
    getMoveLayerId: () => string | null;
    /** 设置是否渲染通用 active 操作框 */
    setActiveRenderEnabled: (enabled: boolean) => void;
}

/** 存储类型 */
interface IStore extends IState, IAction {}

/** 创建存储 */
const createState = (_identity: string) => {
    const store = create<IStore>((set, get) => ({
        moveLayerId: null,
        activeRenderEnabled: true,
        setMoveLayerId(layerId) {
            set({ moveLayerId: layerId });
        },
        getMoveLayerId() {
            return get().moveLayerId;
        },
        setActiveRenderEnabled(activeRenderEnabled) {
            set({ activeRenderEnabled });
        },
    }));

    return store;
};

/** 存储名称 */
const name = 'move-state';

/** 存储类型 */
type ModuleType = StateType<IStore, typeof name>;

/**
 * 订阅当前编辑器的鼠标操作状态
 *
 * @returns 当前编辑器对应的 Zustand store hook
 */
export const useMoveState = () => useState<ModuleType>()[name];

/** 通过 id 获取存储 */
export const getMoveState = (identity: string) => {
    return getState<ModuleType>(identity)[name].getState();
};

const moveState: IExportState = {
    name,
    createState,
};

export default moveState;
